import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getCommercialsBySiteId = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/site-commertials/${id}`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};

// /api/stakeholder-mapping/stakeholders/add
export const createCommercialBySiteId = async (id, data) => {
  // {
  //     "siteId": "0021d9d7-7bfa-4841-85ce-8b50905f1beb",
  //     "feeCategory": "Test category",
  //     "amount": 200,
  //     "type": "Digital"
  // }
  return new Promise(async (resolve, reject) => {
    try {
      let postData = { siteId: id, ...data };
      const response = await axiosInstance.post(
        `/api/site-commertials/add`,
        postData
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const deleteCommercialById = async (assetId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.delete(
        `/api/site-commertials/delete/${assetId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error deleting stakeholder:", error);
      reject(error);
    }
  });
};
